import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { accountRoleSchema } from '../../../schemas/account-role.schema';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Get a paginated list of users for a Trimble Maps Product and Account relationship
 * @param product Trimble Maps product
 * @param accountId Id of the Account
 * @param params Paged Collection Params
 * @returns Paginated list of users for a Trimble Maps Product and Account relationship
 */
export function getProductAccountUserList(
  this: unknown,
  product: string,
  accountId: number,
  params?: PagedCollectionParams
) {
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).productsUrl}/${encodeURIComponent(
        product
      )}/accounts/${encodeURIComponent(accountId)}/user-list${
        params ? `?${params.urlParams}` : ''
      }`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(createPagedCollectionSchema(accountRoleSchema)));
}
